export const BUTTON_CLICKED = 'app/BUTTON_CLICKED';

export const buttonClicked = payload => ({
  type: BUTTON_CLICKED,
  payload,
});
